
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDxITpYUBCsSAfHDseI7xIXx42bnwTgLIs",
  authDomain: "codepen-26263.firebaseapp.com",
  projectId: "codepen-26263",
  storageBucket: "codepen-26263.appspot.com",
  messagingSenderId: "725307473014",
  appId: "1:725307473014:web:3a15a01f4e733ff33b3357",
  measurementId: "G-7DR16D3PGM"
};

// Initialize Firebase
//const app = initializeApp(firebaseConfig);
//export const auth=getAuth(app);

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // Initialize Authentication
const db = getFirestore(app); // Initialize Firestore

export { auth, db, GoogleAuthProvider };